/* eslint-disable */
import { modalActions, productActions } from '@/Actions';
import MinMaxInput from '@/Components/AddProductParameters/minMaxInput';
import { Button } from '@/Components/ui/button';
import { Trash2 } from 'lucide-react';
import { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import ProductVariantsModal from '@/Components/Modals/ProductVariantsModal/ProductVariantsModal';
import { modalTypes } from '@/Constants';
import { getUnitConvertedUnit } from '@/Helpers';

function Accompaniments(props) {
  const {
    modalMode,
    groups = {},
    accompanimentsData,
    handleAccompanimentChange = () => { },
    isDisabled = false,
    compMode = 'product',
  } = props;

  const dispatch = useDispatch();
  const products = useSelector((state) => state.product.products);

  const openProductModal = () => {
    if (modalMode === 'PRODUCT_ACCOMPANIMENTS') {
      dispatch(modalActions.toggleModal(modalTypes[modalMode], true, {
        groupId: 'ACCOMPANIMENTS',
        itemTypes: [
          'PRODUCT',
          'INTERMEDIATE',
          'INGREDIENT',
          'PACKAGING',
          'UNPACKED_PRODUCT',
          'OTHER',
        ],
      }));
    } else {
      dispatch(modalActions.toggleModal(modalMode, true, {
        groupId: 'ACCOMPANIMENTS',
        itemTypes: [
          'PRODUCT',
          'INTERMEDIATE',
          'INGREDIENT',
          'PACKAGING',
          'UNPACKED_PRODUCT',
          'OTHER',
        ],
      }));
    }
  };

  const handleConfirm = (variantObj) => {
    let newData = {};
    const findselectProductData = Object.values(products).find((product) => product.id === variantObj.productId);
    const findselectVariantData = Object.values(findselectProductData.ProductVariant).find((variant) => variant.id === variantObj.variantId);
    newData = {
      productId: findselectProductData.id,
      productName: findselectProductData.productName,
      productImage: findselectProductData.productImageUrl,
      variantId: findselectVariantData.id,
      variantName: findselectVariantData.displayName,
      qty: 1,
      unit: findselectProductData?.unit,
    }
    handleAccompanimentChange([...accompanimentsData, newData]);
  }

  const handleValueChange = (name, value, id) => {
    const updatedAccompaniments = accompanimentsData.map((accompaniment) => {
      if (Number(accompaniment.variantId) === Number(id)) {
        if (value === 0) {
          return {
            ...accompaniment,
            qty: '',
            unit: accompaniment.unit,
          }
        }
        return {
          ...accompaniment,
          unit: accompaniment.unit,
          qty: value,
        }
      }
      return accompaniment;
    });
    handleAccompanimentChange(updatedAccompaniments);
  }

  const removeAccompaniment = (id) => {
    const updatedAccompaniments = accompanimentsData.filter((accompaniment) => accompaniment.variantId !== id);
    handleAccompanimentChange(updatedAccompaniments);
  }
  return (
    <div className='w-full'>
      <ProductVariantsModal
        modalMode={modalMode}
        groups={groups}
        accompaniments={true}
        handleConfirm={handleConfirm}
        isAccompaniment={true}
      />
      {compMode === 'product' && (
        <span className='text-lg text-slate-600 mb-3'>PRODUCT LEVEL ACCOMPANIMENTS</span>
      )}
      <div className='bg-blue-50 p-4 rounded-lg'>
        {isDisabled && (compMode === 'product' && accompanimentsData.length === 0) ? (
          <span className='text-[12px] text-slate-600 mb-3'>No Accompaniments Defined For this Product</span>
        ) : (isDisabled && compMode === 'variant' && accompanimentsData.length === 0) ? (
          <span className='text-[12px] text-slate-600 mb-3'>No Accompaniments Defined For this Variant</span>
        ) : !isDisabled && (
          <Button
            onClick={openProductModal}
            disabled={isDisabled}
            className='bg-yellow-500 hover:bg-yellow-600 text-black font-medium px-4 py-2 rounded-md mb-3'
          >
            + Add Accompaniment
          </Button>
        )}
        <div className='flex flex-wrap gap-4 items-center'>
          {accompanimentsData.length > 0 && accompanimentsData.map((accompaniment) => (
            <div key={accompaniment.variantId} className="relative group">
              <div className='h-[120px] bg-[#F9F9F9] rounded-[12px] shadow-sm overflow-hidden border border-gray-600 flex flex-row justify-between items-center'>
                <div className='w-[120px] h-[120px] '>
                  <img
                    src={accompaniment.productImage}
                    alt={accompaniment.productName}
                    className='w-full h-full object-cover'
                  />
                </div>
                <div className='p-3'>
                  <p className='text-[12px] w-[100px] flex flex-col gap-[1px] whitespace-nowrap font-medium mb-2'>
                    <span className='text-ellipsis overflow-hidden'>{accompaniment.productName}</span>
                    <span>{accompaniment.variantName && ` ${accompaniment.variantName}`}</span>
                  </p>
                  <div className='flex flex-col gap-1'>
                    <div className='flex items-center justify-between text-xs text-gray-600 mb-1'>
                      <span className='text-[12px] text-slate-600'>Quantity</span>
                      <span className='text-[12px] text-slate-600'>{getUnitConvertedUnit(accompaniment.qty, accompaniment.unit, true)}</span>
                    </div>
                    <MinMaxInput
                      id={accompaniment.variantId}
                      value={Number(accompaniment.qty)}
                      initialValue={1}
                      notNegative={true}
                      handleMinMaxChange={handleValueChange}
                      disabled={isDisabled}
                    />
                  </div>
                </div>
              </div>
              {!isDisabled && (
                <button
                  onClick={() => removeAccompaniment(accompaniment.variantId)}
                  className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow-md border border-gray-300 opacity-100 group-hover:opacity-100 transition-opacity"
                  aria-label="Remove item"
                >
                  <Trash2 className="text-gray-600 hover:text-red-500" size={16} />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    productList: state.product.productList,
  };
};

export default connect(mapStateToProps)(Accompaniments);
